import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import BaseLayout from '@/layouts/base';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleX />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>404</PageHeadingTitle>
        <PageHeadingDescription>{t('404Page.title')}</PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <Link to="/">{t('buttons.continue')}</Link>
      </Button>
    </BaseLayout>
  );
};
NotFoundPage.displayName = 'NotFoundPage';

export default NotFoundPage;
